<template>
  <div class="type-icon">
    <i
      v-if="type === 'info'"
      class="iconfont dm-warning"
      :style="{ fontSize: '40px', color: '#6B7280' }"
    />
    <i
      v-if="type === 'warning'"
      class="iconfont dm-warning"
      :style="{ fontSize: '40px', color: '#ffb800' }"
    />
    <q-icon
      v-if="type === 'error'"
      name="font:dm-warning"
      size="40px"
      color="negative"
    />
    <q-icon
      v-if="type === 'timeout'"
      name="schedule"
      size="46px"
      color="grey-6"
    />
    <q-circular-progress
      v-if="type === 'waiting'"
      :thickness="0.25"
      indeterminate
      size="40px"
      color="primary"
    />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'error',
    },
  },
};
</script>

<style></style>
